module.exports = __webpack_public_path__ + "static/media/ArrowRightBlue.784b171a.svg";